import React from "react";
import { Box, Paper, Typography, alpha, Divider } from "@mui/material";

export const MapLegend: React.FC = () => {
  return (
    <Paper
      elevation={2}
      sx={{
        position: "absolute",
        bottom: 24,
        left: 24,
        zIndex: 10,
        p: 2,
        borderRadius: 2,
        backgroundColor: (theme) =>
          theme.palette.mode === "dark"
            ? alpha(theme.palette.background.paper, 0.95)
            : alpha(theme.palette.background.paper, 0.98),
        backdropFilter: "blur(8px)",
        maxWidth: 180,
      }}
    >
      <Typography
        variant="caption"
        fontWeight={600}
        gutterBottom
        display="block"
      >
        Project Status
      </Typography>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5, mt: 1 }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Box
            sx={{
              width: 12,
              height: 12,
              borderRadius: "50%",
              bgcolor: "success.main",
            }}
          />
          <Typography variant="caption">On Track</Typography>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Box
            sx={{
              width: 12,
              height: 12,
              borderRadius: "50%",
              bgcolor: "warning.main",
            }}
          />
          <Typography variant="caption">At Risk</Typography>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Box
            sx={{
              width: 12,
              height: 12,
              borderRadius: "50%",
              bgcolor: "error.main",
            }}
          />
          <Typography variant="caption">Critical</Typography>
        </Box>
      </Box>

      <Divider sx={{ my: 1.5 }} />

      <Typography
        variant="caption"
        fontWeight={600}
        gutterBottom
        display="block"
      >
        Network Boundaries
      </Typography>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5, mt: 1 }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Box
            sx={{
              width: 16,
              height: 12,
              bgcolor: (theme) => alpha(theme.palette.info.main, 0.15),
              border: 1,
              borderColor: (theme) => alpha(theme.palette.info.main, 0.4),
              borderRadius: 0.5,
            }}
          />
          <Typography variant="caption">Network Area</Typography>
        </Box>
      </Box>

      <Divider sx={{ my: 1.5 }} />

      <Typography
        variant="caption"
        fontWeight={600}
        gutterBottom
        display="block"
      >
        Clusters
      </Typography>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5, mt: 1 }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Box
            sx={{
              width: 14,
              height: 14,
              borderRadius: "50%",
              bgcolor: "success.main",
              border: 2,
              borderColor: "background.paper",
            }}
          />
          <Typography variant="caption">All On Track</Typography>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Box
            sx={{
              width: 14,
              height: 14,
              borderRadius: "50%",
              bgcolor: "warning.main",
              border: 2,
              borderColor: "background.paper",
            }}
          />
          <Typography variant="caption">Has At Risk</Typography>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Box
            sx={{
              width: 14,
              height: 14,
              borderRadius: "50%",
              bgcolor: "error.main",
              border: 2,
              borderColor: "background.paper",
            }}
          />
          <Typography variant="caption">Has Critical</Typography>
        </Box>
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{ mt: 0.5, fontSize: "0.65rem" }}
        >
          Size indicates project count
        </Typography>
      </Box>
    </Paper>
  );
};
